module.exports = __webpack_public_path__ + "img/la-la-land.349405b5.jpg";